<div class="bar">
    <div class="fill"></div>
</div>

<style>
    .bar {
        width: 100%;
        height: 6px;
        border-radius: 999px;
        background: #66666630;
        overflow: hidden;
    }

    .fill {
        height: 100%;
        width: 100%;
        transform-origin: left;
        background: linear-gradient(90deg, #22c55e, #11b44d, #00a33c);
        background-size: 200% 100%;
        animation:
            grow 3s ease-out forwards,
            shine 1.2s linear infinite;
    }

    @keyframes grow {
        0% {
            transform: scaleX(0.02);
        }
        15% {
            transform: scaleX(0.3);
        }
        40% {
            transform: scaleX(0.55);
        }
        70% {
            transform: scaleX(0.75);
        }
        100% {
            transform: scaleX(1);
        }
    }

    @keyframes shine {
        0% {
            background-position: 0% 0;
        }
        100% {
            background-position: 200% 0;
        }
    }
</style>
